import { ButtonAction, ButtonProps } from '@/shared/types/button';

import { actionHandlers } from '@/front/actions/handlers';
import { confirmModal } from '@/front/modal';

document.addEventListener('DOMContentLoaded', () => initButtons());

export const initButtons = (root: ParentNode = document) => {
  const buttons = root.querySelectorAll<HTMLAnchorElement | HTMLButtonElement>('a[data-action], button[data-action]');

  for (const button of buttons) {
    addButtonClickEventListener(button);
  }
};

const setButtonInProgress = (button: HTMLAnchorElement | HTMLButtonElement, inProgress: boolean) => {
  if (inProgress) {
    button.dataset.inProgress = 'true';
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('disabled');

    if (button instanceof HTMLButtonElement) {
      button.disabled = true;
    }
  } else {
    delete button.dataset.inProgress;
    button.removeAttribute('aria-disabled');
    button.classList.remove('disabled');

    if (button instanceof HTMLButtonElement) {
      button.disabled = false;
    }
  }
};

const addButtonClickEventListener = (button: HTMLAnchorElement | HTMLButtonElement) => {
  button.addEventListener('click', async (event) => {
    event.preventDefault();

    const disabled = (button.dataset.disabled ?? 'false') === 'true';
    const inProgress = (button.dataset.inProgress ?? 'false') === 'true';

    // Prevent double submit.
    if (disabled || inProgress) {
      return;
    }

    setButtonInProgress(button, true);

    try {
      await handler(button);
    } finally {
      if (button.closest('form')?.dataset.submitted !== 'true') {
        setButtonInProgress(button, false);
      }
    }
  });
};

const handler = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const { confirmMessage, confirmButtonLabel, confirmButtonVariant } = button.dataset as Pick<
    ButtonProps,
    'confirmMessage' | 'confirmButtonLabel' | 'confirmButtonVariant'
  >;

  if (!confirmMessage || (await confirmModal(confirmMessage, confirmButtonLabel, confirmButtonVariant))) {
    const action = button.dataset.action as ButtonAction;
    await actionHandlers[action](button);
    toggleIcon(button);
  }
};

const toggleIcon = (button: HTMLAnchorElement | HTMLButtonElement) => {
  const toggleIcon = button.dataset.toggleIcon;
  const icon = button.querySelector('i');

  if (icon && toggleIcon) {
    const currentIcon = icon.className;
    icon.className = toggleIcon;
    button.dataset.toggleIcon = currentIcon;
  }
};
